(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('.htu3-reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initCoats() {
    var root = document.querySelector('[data-htu3-coats]');
    if (!root) return;
    var images = root.querySelectorAll('[data-htu3-sample]');
    var heading = root.querySelector('[data-htu3-coat-heading]');
    var desc = root.querySelector('[data-htu3-coat-desc]');
    var tabs = root.querySelectorAll('[data-htu3-coat]');
    function setCoats(n) {
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-htu3-sample') === n);
      });
      tabs.forEach(function (b) {
        var active = b.getAttribute('data-htu3-coat') === n;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          if (heading) heading.textContent = b.getAttribute('data-heading') || '';
          if (desc) desc.textContent = b.getAttribute('data-text') || '';
        }
      });
    }
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () { setCoats(btn.getAttribute('data-htu3-coat')); });
    });
    setCoats('2');
  }

  function initTechniques() {
    var root = document.querySelector('[data-htu3-techex]');
    if (!root) return;
    var stage = root.querySelector('[data-htu3-stage-btn]');
    var stageImg = root.querySelector('[data-htu3-stage-img]');
    var stagePlaceholder = root.querySelector('[data-htu3-stage-placeholder]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-htu3-tech]'));
    var headingEl = root.querySelector('[data-htu3-tech-heading]');
    var descEl = root.querySelector('[data-htu3-tech-desc]');
    var lightbox = root.querySelector('[data-htu3-lightbox]');
    var lbImg = lightbox.querySelector('[data-htu3-lightbox-img]');
    var lbName = lightbox.querySelector('[data-htu3-lightbox-name]');
    var lbDesc = lightbox.querySelector('[data-htu3-lightbox-desc]');
    var lbClose = lightbox.querySelector('[data-htu3-lightbox-close]');
    var lbPrev = lightbox.querySelector('[data-htu3-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-htu3-lightbox-next]');
    var current = 0;
    var lastFocused = null;

    function applyStage(btn) {
      var src = btn.getAttribute('data-stage-src');
      stage.classList.toggle('has-image', !!src);
      if (src) {
        stageImg.src = src;
        stageImg.alt = btn.getAttribute('data-alt') || '';
        stageImg.classList.remove('is-hidden');
        stagePlaceholder.hidden = true;
      } else {
        stageImg.classList.add('is-hidden');
        stagePlaceholder.hidden = false;
        stagePlaceholder.textContent = btn.getAttribute('data-placeholder') || '';
      }
      stageImg.classList.remove('is-fading');
    }

    function setActive(index) {
      var btn = items[index];
      if (!btn) return;
      current = index;
      items.forEach(function (b, i) {
        var active = i === index;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (reduceMotion) {
        applyStage(btn);
      } else {
        stageImg.classList.add('is-fading');
        setTimeout(function () { applyStage(btn); }, 150);
      }
      if (headingEl) headingEl.textContent = btn.getAttribute('data-name') || '';
      if (descEl) descEl.textContent = btn.getAttribute('data-text') || '';
    }

    items.forEach(function (btn, i) {
      btn.addEventListener('click', function () { setActive(i); });
    });

    function updateLightbox(index) {
      var btn = items[index];
      if (!btn) return;
      current = index;
      var src = btn.getAttribute('data-light-src') || btn.getAttribute('data-stage-src');
      if (src) {
        lbImg.src = src;
        lbImg.alt = btn.getAttribute('data-alt') || '';
        lbImg.hidden = false;
      } else {
        lbImg.hidden = true;
      }
      lbName.textContent = btn.getAttribute('data-name') || '';
      lbDesc.textContent = btn.getAttribute('data-text') || '';
      setActive(index);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') { updateLightbox((current - 1 + items.length) % items.length); }
      else if (e.key === 'ArrowRight') { updateLightbox((current + 1) % items.length); }
      else if (e.key === 'Tab') {
        var focusable = lightbox.querySelectorAll('button');
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function openLightbox(index) {
      lastFocused = document.activeElement;
      updateLightbox(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lbClose.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    stage.addEventListener('click', function () {
      if (!stage.classList.contains('has-image')) return;
      openLightbox(current);
    });
    lbClose.addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { updateLightbox((current - 1 + items.length) % items.length); });
    lbNext.addEventListener('click', function () { updateLightbox((current + 1) % items.length); });
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

    applyStage(items[0]);
  }

  function init() { initReveal(); initCoats(); initTechniques(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
